import React from 'react';
import { useScrollAnimation } from '../hooks/useScrollAnimation';
import { usePortfolio } from '../context/PortfolioContext';

const Clients = () => {
  const { clients, loading } = usePortfolio();
  const [ref, isVisible] = useScrollAnimation(0.1);

  if (loading || !clients.length) return null;

  return (
    <section id="clients" className="py-24 md:py-32 bg-white overflow-hidden">
      <div className="max-w-7xl mx-auto px-6">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Trusted by Industry Leaders
          </h2>
          <p className="text-lg text-gray-700">
            Serving top companies across diverse industries globally.
          </p>
        </div>

        {/* Clients Image with Animation */}
        <div
          ref={ref}
          className={`flex items-center justify-center ${
            isVisible ? 'animate-fade-in-up' : 'animate-on-scroll'
          }`}
        >
          <div className="w-full max-w-5xl">
            <img
              src={clients[0].logo}
              alt="Client Portfolio"
              className="w-full h-auto object-contain"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Clients;